<script setup lang="ts">
import { ReactionState } from '@/composition/reactions'
import { ReactionType } from '@/models/Reaction'
import { UISpin } from '@gohighlevel/ghl-ui'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { openUserProfile } from '../helper'

const { t } = useI18n()
const MAX_PROFILE_LIST_SIZE = 8
const router = useRouter()
const route = useRoute()
const props = defineProps({
  contentId: {
    type: String,
    required: true,
  },
  reactionType: {
    type: String,
    required: true,
  },
  contentReactionsCount: {
    type: Number,
    required: true,
  },
})

onMounted(async () => {
  await getReactionsData()
})

async function getReactionsData() {
  try {
    if (!isLoading.value) {
      await ReactionState.fetchReactions(
        props.contentId,
        ReactionType[props.reactionType],
        {
          limit: MAX_PROFILE_LIST_SIZE,
        }
      )
    }
  } catch (error) {
    console.error(error)
  }
}

const reactions = computed(() => {
  return ReactionState.state.contentReactions
    .get(props.contentId)
    ?.get(ReactionType[props.reactionType])
})

const isLoading = computed(() => {
  return (
    ReactionState.state.isLoading
      .get(props.contentId)
      ?.get(ReactionType[props.reactionType]) ?? false
  )
})
</script>
<template>
  <div class="bg-communities-background px-3.5 py-2 text-center">
    <div>
      <div v-if="!isLoading" class="w-[130px] flex-col">
        <div v-if="reactions && reactions.length > 0">
          <div
            v-for="reaction in reactions.slice(0, MAX_PROFILE_LIST_SIZE)"
            :key="reaction._id"
            tabindex="0"
            role="button"
            aria-label="Reacted User"
            class="flex cursor-pointer flex-row"
            @keyup.enter="
              openUserProfile(reaction.reactedUser?.slug, route, router)
            "
            @click.stop="
              openUserProfile(reaction.reactedUser?.slug, route, router)
            "
          >
            <div
              class="text-md post_content truncate text-start text-communities-font-primary hover:text-communities-font-primary"
            >
              {{ reaction.reactedUser?.fullName || 'Deleted User' }}
            </div>
          </div>
          <div
            v-if="contentReactionsCount > MAX_PROFILE_LIST_SIZE"
            class="text-md post_content line-clamp-2 text-start text-communities-font-primary"
          >
            {{
              t('reaction.andOthers', {
                count: contentReactionsCount - MAX_PROFILE_LIST_SIZE,
              })
            }}
          </div>
        </div>
        <div
          v-else
          class="text-md post_content line-clamp-2 text-communities-font-primary"
        >
          {{ t('reaction.noLikes') }}
        </div>
      </div>
      <div v-else class="flex w-[268px] items-center justify-center">
        <UISpin />
      </div>
    </div>
  </div>
</template>
